// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MergeCellsOutlinedSvg from "@ant-design/icons-svg/es/asn/MergeCellsOutlined";
import AntdIcon from '../components/AntdIcon';

var MergeCellsOutlined = function MergeCellsOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MergeCellsOutlinedSvg
  }));
};

MergeCellsOutlined.displayName = 'MergeCellsOutlined';
export default React.forwardRef(MergeCellsOutlined);